export default {
  business_no: '业务编号',
  business_name: '业务名称',
  business_type: '业务类型',
  select_business_type: '请选择业务类型',
  self_operated: '自营',
  franchise: '加盟',
  business_region: '交易地区',
  business_currency: '交易币种',
  related_franchisee: '关联加盟商',
  select_region: '请选择地区',
  select_currency: '请选择币种',
  select_franchisee: '请选择加盟商',
  description: '描述',
  enter_description: '请输入描述',
  create_time: '创建时间',
  create_business: '新增业务',
  edit_business: '编辑业务',
  business_detail: '业务详情',
  create_success: '创建成功',
  edit_success: '编辑成功',
  enter_business_name: '请输入业务名称',
  franchisee_no: '加盟商编号',
  franchisee_name: '加盟商名称',
  region: '地区',
  currency: '币种',
  remark: '备注',
  enter_remark: '请输入备注',
  contact_name: '联系人姓名',
  enter_contact_name: '请输入联系人姓名',
  contact_phone: '联系人电话',
  enter_phone: '请输入电话号码',
  contact_email: '联系人邮箱',
  enter_email: '请输入邮箱地址',
  create_franchisee: '新增加盟商',
  edit_franchisee: '编辑加盟商',
  franchisee_detail: '加盟商详情',
  confirm_submit: '确认提交',
  confirm_franchisee: '请确认以下加盟商信息',
  submit: '提交',
  franchisee_create_success: '加盟商创建成功',
  franchisee_edit_success: '加盟商编辑成功',
  enter_franchisee_name: '请输入加盟商名称',
  select_business: '请选择业务',
  copy_success: '复制成功',
  business_no_export: '业务编号',
  business_name_export: '业务名称',
  franchisee_no_export: '加盟商编号',
  franchisee_name_export: '加盟商名称',
  business: '业务',
  franchisee: '加盟商'
}
